import { TopPage } from "@/components/elements/TopPage";
import { CreateCompanyUserForm } from "@/features/company/components/CreateCompanyUserForm";
import { AppRoutes } from "@/routes/config";
import { getDynamicRoute } from "@/utils/url";
import { Box, Stack } from "@mui/material";
import { FC } from "react";
import { useParams } from "react-router-dom";
import { styled } from "@mui/system";

type TCompanyUserCreatePageProps = {};

export const CompanyUserCreate: FC<TCompanyUserCreatePageProps> = () => {
  const { id } = useParams();

  return (
    <CompanyWrapper sx={{ mt: 1 }}>
      <Box sx={{ mb: 2.5 }}>
        <Stack gap={4}>
          <TopPage
            backUrl={getDynamicRoute(AppRoutes.companyDetail, { id })}
            title="新規顧客ユーザーの追加"
            description="顧客側画面にログインできるユーザーを新しく作成し、パスワードの新規登録リンクを含むログイン情報をメールアドレス宛に送付します。"
            enablePageBack={false}
          />
          <CreateCompanyUserForm />
        </Stack>
      </Box>
    </CompanyWrapper>
  );
};

const CompanyWrapper = styled(Stack)`
  width: 1198px;
  margin: 0 auto;
`;
